var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"px-0",attrs:{"color":"primary","icon":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{staticClass:"mx-0"},[_vm._v("fas fa-print")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }